import React from "react";
import {useTranslation} from "react-i18next";

import { CheckCircle as CheckCircleIcon } from '@vedmarket/ui-kit';
import { NotInterested as NotInterestedIcon } from '@vedmarket/ui-kit';

import { Completed } from '@vedmarket/ui-kit';
import MenuButton from '../../../../../../../../common/menuButton';
import {COLORS} from "../../../../../../../../../config/constants";

import './preferences-completed.scss';
import Typography from '@mui/material/Typography';
import {formatHSCode} from 'utils/helpers';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';

const PreferencesCompleted = ({hasPreferences, code, handleEdit}: CustomsPreferencesCompletedProps) => {

  const { t } = useTranslation()

  const getCompletedInfo = () => [
    {
      label: <Typography component='span' variant='inherit'>{formatDemoCopy(t('calc__text__customs__allNecessaryConditionsAreFulfilled'))}</Typography>,
      value: hasPreferences ?
        <span className='preferences-value'>
          <CheckCircleIcon  style={{
            color: COLORS.GREEN,
            marginRight: '4px',
            width: '20px'
          }}/><Typography component='span' variant='inherit'>{formatDemoCopy(t('calc__text__customs__confirmPreferences'))}</Typography></span>
        : <span className='preferences-value'>
          <NotInterestedIcon style={{
            color: COLORS.MEDIUM_GRAY,
            marginRight: '4px',
            width: '20px'
          }}/>
          <Typography component='span' variant='inherit'>{formatDemoCopy(t('calc__text__customs__refusePreferences'))}</Typography>
        </span>
    }
  ]

  return <div className='preferences-completed'>
    <Completed
      info={getCompletedInfo()}
      isFullRow
      caption={<Typography component='span' variant='inherit'>{formatDemoCopy(`${t('calc__text__customs__preferencesForTheHSCode')} ${formatHSCode(code)}`)}</Typography>}
      onEdit={handleEdit}
      MenuComponent={MenuButton}
      backgroundColor={false}
    />
  </div>
}

export default PreferencesCompleted
